<script lang="ts" setup>
import { computed } from 'vue'

import { useLessonRoomStore } from '@stores/lesson-room'

import { useLessonRoomAnalytics } from '@hooks/lesson-room/lesson-room-analytics.hook'
import { useRoomLiveKit } from '@hooks/classroom/room-live-kit.hook'

import LessonRoomControlButton from '@Atoms/LessonRoom/LessonRoomControlButton.vue'

defineOptions({
  name: 'ButtonSettings',
})

const lessonRoomStore = useLessonRoomStore()
const { trackClickSettings } = useLessonRoomAnalytics()
const { connectionState } = useRoomLiveKit()

const isReady = computed<boolean>(() => connectionState.value === 'connected')

// A blocked camera/mic can't be configured — keep the drawer shut until the user
// fixes permissions and reloads (main-app parity).
const isBlocked = computed<boolean>(() => lessonRoomStore.isDeniedMic || lessonRoomStore.isDeniedCam)

const handleClick = (): void => {
  trackClickSettings()
  lessonRoomStore.setSettingsOpen(!lessonRoomStore.isSettingsOpen)
}
</script>

<template>
  <LessonRoomControlButton
    :icon="{ name: 'gear' }"
    label="Settings"
    :enabled="lessonRoomStore.isSettingsOpen"
    :disabled="!isReady || isBlocked"
    @click="handleClick"
  />
</template>
